import React, { useRef, useEffect } from 'react';
import { IProps } from './types';

const Captcha:React.SFC<IProps> = (props) => {
  /**
   * @description 產生一個隨機亂數 得到一個兩數之間的隨機整數
   * @param min 產生亂數用數值
   * @param max 產生亂數用數值
   */
  const randomNum = (min:number, max:number): number => {
    return Math.floor(createDynamicNumber() * (max - min) + min);
  };

  /**
   * @description (源碼掃描) 產生動態數字段
   */
  const createDynamicNumber = ():number => {
    const patchNum = (new Date()).getTime().toString().split('').reverse().join('');
    const patchNumReverse = patchNum.split('').reverse().join('');
    const num = +`0.${window.crypto.getRandomValues(new Uint32Array(1))[0]}${patchNum}${patchNumReverse}`;
    return num;
  };

  /**
     * @description 產生一個隨機色
     * @param min 產生亂數用數值
     * @param max 產生亂數用數值
     */
  const randomColor = (min:number, max:number):string => {
    const r = randomNum(min, max);
    const g = randomNum(min, max);
    const b = randomNum(min, max);

    return `rgb(${r},${g},${b})`;
  };

  /**
     * @description 繪製驗證碼圖片
     * @param captchaText 驗證碼
     */
  const drawPic = (canvasRef:any):CanvasRenderingContext2D => {
    // 取得畫布
    const canvasDOM:HTMLCanvasElement = canvasRef.current;

    // 獲取該canvas的2D繪圖環境對象
    const ctx = canvasDOM.getContext('2d') as CanvasRenderingContext2D;

    // canvas 重設寬或高就會重置，先重置畫布
    const height = canvasDOM.height;
    canvasDOM.height = height;

    // 設置文本基線是畫布的底部
    ctx.textBaseline = 'bottom';

    // 繪製背景色
    // 顏色若太深可能導致看不清
    // ctx.fillStyle = randomColor(0, 0);

    const imgData = ctx.createImageData(canvasDOM.width, canvasDOM.height);

    const pixels = imgData.data;

    const numPixels = imgData.width * imgData.height;

    for (let i = 0; i < numPixels; i += 1) {
      const color = randomNum(0, 255);
      pixels[i * 4] = color; // Red
      pixels[i * 4 + 1] = color; // Green
      pixels[i * 4 + 2] = color; // Blue
      pixels[i * 4 + 3] = 50; // Alpha
    }

    ctx.putImageData(imgData, 0, 0);

    // 畫出矩形
    // ctx.fillRect(0, 0, props.width, props.height);
    return ctx;
  };

  /**
     * @description 繪製文字
     * @param ctx canvas 元素
     */
  const drawCaptchaText = (ctx:CanvasRenderingContext2D) => {
    for (let i = 0; i < props.captchaText.length; i += 1) {
      // 隨機生成字體顏色
      ctx.fillStyle = randomColor(255, 255);

      // 隨機生成字體大小
      ctx.font = `${randomNum(15, 30)}px SimHei`;

      // 隨機生成旋轉角度。
      const deg = randomNum(-5, 5);

      // 旋轉元素
      ctx.rotate(deg * Math.PI / 180);

      // 元素在水平方向上的位置。
      const x = 10 + i * 15;

      // 元素在豎直方向上的位置，儘量保持在中間，防止部分元素在畫布外。 width 100 heigh 40
      const y = randomNum(30, 40);

      // 平移元素
      ctx.translate(x, y);

      // 繪製文字
      ctx.fillText(props.captchaText[i], 0, 0);

      // 恢復坐標原點和旋轉角度
      ctx.rotate(-deg * Math.PI / 180);

      ctx.translate(-x, -y);
    }
  };

  // /**
  //    * @description 繪製干擾線
  //    * @param ctx canvas 元素
  //    */
  // const drawCurveLines = (ctx:CanvasRenderingContext2D) => {
  //   for (let i = 0; i < props.curveLineCount; i += 1) {
  //     // 設定干擾線顏色
  //     ctx.strokeStyle = randomColor(40, 180);

  //     // 開始繪製
  //     ctx.beginPath();

  //     // 起點位置
  //     ctx.moveTo(randomNum(0, props.width), randomNum(0, props.height));

  //     // 終點位置
  //     ctx.lineTo(randomNum(0, props.width), randomNum(0, props.height));

  //     ctx.stroke();
  //   }
  // };

  // /**
  //    * @description 繪製干擾點
  //    * @param ctx canvas 元素
  //    */
  // const drawDots = (ctx:CanvasRenderingContext2D) => {
  //   for (let i = 0; i < props.dotCount; i += 1) {
  //     // 設定干擾點顏色
  //     ctx.fillStyle = randomColor(0, 255);

  //     // 開始繪製
  //     ctx.beginPath();

  //     // ctx.arc(x,y,r,sAngle,eAngle,counterclockwise)
  //     // x圓的中心的 x 坐標
  //     // y圓的中心的 y 坐標
  //     // r圓的半徑
  //     // sAngle起始角，以弧度計。（弧的圓形的三點鐘位置是 0 度）。
  //     // eAngle結束角，以弧度計。
  //     // counterclockwise可選。規定應該逆時針還是順時針繪圖。False = 順時針，true = 逆時針。
  //     ctx.arc(
  //       randomNum(0, props.width),
  //       randomNum(0, props.height),
  //       1,
  //       0,
  //       2 * Math.PI,
  //       true
  //     );

  //     ctx.fill();
  //   }
  // };

  const canvasRef = useRef() as React.MutableRefObject<HTMLCanvasElement>;
  useEffect(() => {
    const ctx = drawPic(canvasRef);
    drawCaptchaText(ctx);
  });

  return (
    <>
      <canvas ref={canvasRef} width={props.width} height={props.height} />
    </>
  );
};

export default Captcha;
